import { render, staticRenderFns } from "./OcclusalMenu.vue?vue&type=template&id=17452692&scoped=true&"
import script from "./OcclusalMenu.vue?vue&type=script&lang=js&"
export * from "./OcclusalMenu.vue?vue&type=script&lang=js&"
import style0 from "./OcclusalMenu.vue?vue&type=style&index=0&id=17452692&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17452692",
  null
  
)

export default component.exports